import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f306bb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "code-form" }
const _hoisted_2 = {
  class: "code-form__phone",
  "data-test": "title"
}
const _hoisted_3 = { class: "code-form__change-phone black-link" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "auth-code",
  class: "base-label"
}, "Код подтверждения", -1))
const _hoisted_5 = { class: "code-form__input-wrapper" }
const _hoisted_6 = { class: "code-form__new-code new-code" }
const _hoisted_7 = {
  key: 0,
  class: "new-code__timer"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Получить новый код", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "code-form__support" }, [
  /*#__PURE__*/_createTextVNode(" Не приходит СМС? "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Напишите на "),
  /*#__PURE__*/_createElementVNode("a", { href: "mailto:support@motmom.com" }, "support@motmom.com")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeField = _resolveComponent("CodeField")!
  const _component_MoPreloader = _resolveComponent("MoPreloader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(" Мы отправили код на "),
      _createElementVNode("span", null, _toDisplayString(_ctx.phone), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('changePhone')))
      }, "Изменить")
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_CodeField, {
        "code-length": 4,
        "is-loading": _ctx.isLoading,
        "error-message": _ctx.errorMessage,
        onSetCode: _ctx.setCode
      }, null, 8, ["is-loading", "error-message", "onSetCode"])
    ]),
    _createElementVNode("button", {
      class: _normalizeClass(["code-form__confirm-code-btn base-btn base-btn--black", {
        'base-btn--disabled': !_ctx.meta.valid,
      }]),
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)))
    }, [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_MoPreloader, {
            key: 0,
            "is-multiple": true
          }))
        : (_ctx.isRegistration)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(" Зарегистрироваться ")
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createTextVNode(" Войти ")
            ], 64))
    ], 2),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.timeLeft > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, " Получить новый код можно через " + _toDisplayString(_ctx.getFormatTime(_ctx.timeLeft)), 1))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "black-link",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('sendNewCode')))
          }, _hoisted_9))
    ]),
    _hoisted_10
  ]))
}